var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCandle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    style: {
      height: 512,
      width: 512
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    className: "",
    transform: "translate(0,0)",
    style: {}
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M334.656 17.125c-39.668 10.85-74.78 27.46-100.75 51.97-.7-12.52-4.5-25.147-13.28-38.032-.99 44.914-50.315 103.934-30.5 153.53.003.01-.005.023 0 .032 7.68 30.364 37.266 53.535 65.468 58.313-2.05-19.67-7.09-37.707-14.47-54.72l17.157-7.437c8.366 19.287 13.92 39.993 16 62.47 23.252-3.66 41.33-23.623 38.283-67.594-3.658-52.788-.63-114.802 22.093-158.53zM209.53 258.72c-31.372.18-59.653 7.37-81.81 19.936-22.914 12.996-39.443 32.518-44.376 55.5-2.557 8.937-4.03 19.326-4.03 30.406 0 32.55 12.64 59.1 28.5 60.532V489.5h301.155v-18.47c1.204.15 2.44.22 3.686.22 16.484 0 29.844-13.362 29.844-29.844 0-15.464-11.78-28.173-26.844-29.687-2.632-46.515-15.848-80.1-41.875-103.47-23.49-21.094-56.093-33.432-98.592-41.78-.3 21.733-3.715 45.06-10.75 70.28l-18.032-5.03c7.006-25.113 10.208-47.738 10.22-68.533-4.84-.782-9.746-1.537-14.813-2.25-11.03-1.55-21.824-2.28-32.282-2.218zm-103.186 79.186h18.687c0 5.588 2.556 11.307 8.69 17.5 6.13 6.194 15.744 12.395 28.06 17.656 24.636 10.524 59.83 17.375 98.75 17.375 49.15 0 92.438-11.197 115.845-26.312l10.125 15.72c-28.443 18.366-74.097 29.28-125.97 29.28-41.077 0-78.3-7.003-106.092-18.875-13.897-5.936-25.473-13.075-34-21.688-8.528-8.612-14.094-19.157-14.094-30.656z",
    fill: "currentcolor",
    fillOpacity: 1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCandle);
export default __webpack_public_path__ + "static/media/candle.b735047712d5f2617290863e786e8e7d.svg";
export { ForwardRef as ReactComponent };